import { addAction, INIT } from '@situation/setdesign.util';

// The LAZ parking widget (third-party script from go.lazparking.com) runs DefaultSize()
// on mobile user agents, which inlines padding-left:0 on every .container and
// background-color:#fff on body. Strip those inline styles so the theme's CSS applies.
addAction(INIT, () => {
    const widget = document.getElementById('LAZ_Widget');
    if (!widget) return;

    const containers = [...document.querySelectorAll('.container')].filter((el) => !widget.contains(el));

    const reset = () => {
        containers.forEach((el) => {
            if (el.style.paddingLeft === '0px') el.style.removeProperty('padding-left');
        });

        if (document.body.style.backgroundColor) document.body.style.removeProperty('background-color');
    };

    // LAZ loads its modules asynchronously, so watch for the inline styles instead of guessing timing
    const observer = new MutationObserver(reset);
    [...containers, document.body].forEach((el) => {
        observer.observe(el, { attributes: true, attributeFilter: ['style'] });
    });

    reset();
});
